import type { FC } from "react"

import WorkInProgressAlert from "@/components/common/Alerts/WorkInProgressAlert"

export const PendingTransferListPage: FC = () => <WorkInProgressAlert />
